/**
 * PublicRoute component for pages that should be accessible without authentication
 * These routes are available to all users, whether authenticated or not
 */
const PublicRoute = ({ children }) => {
  // Public routes always render their children without any authentication checks
  return children;
};

export default PublicRoute;
